<template>
    <div class="collection">
        <alllistNews :datalink="phplink+'app/index.php?id=zhiyuanfengcai&ot=1'"></alllistNews>
    </div>
</template>

<script>
import alllistNews from "./newlistDownUpTwo.vue" //养心金寨
export default {
    components:{
        alllistNews
    },
    data(){
        return{
            java:'java'
        }
    },
    created(){
    },
    methods:{
    }
}
</script>

<style>
    .collection{
        width: 100%;
        height: 100%;
    }
</style>